export default {
  BASE_URL: 'https://api.target.com/application_metrics/v1/',
}
